var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAra(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 30,
    viewBox: "0 0 45 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H45V30H0V0Z",
    fill: "#E2E4E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7248 10.1467L39.2568 21.2641H36.8515L35.7075 18.4774H31.0435L29.8848 21.2641H27.4648L32.0995 10.1467H34.7248ZM31.8355 16.5707H34.9302L33.4048 12.8161L31.8355 16.5707Z",
    fill: "#3C3C3C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3797 16.0134C23.421 16.0134 24.081 15.2507 24.081 14.0334C24.081 12.8161 23.421 12.0534 22.3797 12.0534H19.681V16.0134H22.3797ZM17.4517 21.2641V10.1467H22.8637C24.8877 10.1467 26.3103 11.7161 26.3103 13.9454C26.3103 15.2654 25.8703 16.5267 24.0957 17.5241L26.8383 21.2641H24.081L21.617 17.9201H19.681V21.2641H17.4517Z",
    fill: "#3C3C3C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.008 10.1467L16.54 21.2641H14.1347L12.9907 18.4774H8.32671L7.16805 21.2641H4.74805L9.38271 10.1467H12.008ZM9.11871 16.5707H12.2134L10.688 12.8161L9.11871 16.5707Z",
    fill: "#3C3C3C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAra);
export default __webpack_public_path__ + "static/media/icon_ara.10daaedc73e42315f0ef3f3bb2f80c10.svg";
export { ForwardRef as ReactComponent };